export const getRecordTypeSlug = (recordTypeName: string): string => recordTypeName.toLowerCase().replaceAll(' ', '-');
